import { s } from '@/theme/tokens';
import { toolbarControlRadius } from '../tableSystem/tableToolbar.helpers';

export const metricsToolbarCollapsedSearchPopoverBodySx = {
  px: s('lg'),
  py: s('lg'),
} as const;

export const metricsToolbarCollapsedSearchFieldSx = {
  width: '100%',
  minWidth: 0,
  '& .MuiInputBase-root, & .MuiOutlinedInput-root': {
    borderRadius: `${toolbarControlRadius} !important`,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: `${toolbarControlRadius} !important`,
  },
} as const;
